import { render, staticRenderFns } from "./lisaa-opintoopas.vue?vue&type=template&id=1a190600&scoped=true&"
import script from "./lisaa-opintoopas.vue?vue&type=script&lang=ts&"
export * from "./lisaa-opintoopas.vue?vue&type=script&lang=ts&"
import style0 from "./lisaa-opintoopas.vue?vue&type=style&index=0&id=1a190600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a190600",
  null
  
)

export default component.exports